"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToasterMessage = void 0;

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _components = require("./components");

const ToasterMessage = _stylitas.styled.div`
  ${_components.toasterMessage};
`;
exports.ToasterMessage = ToasterMessage;
ToasterMessage.displayName = 'ToasterMessage';
ToasterMessage.propTypes = {
  children: _propTypes.node
};